module.exports = __webpack_public_path__ + "assets/img/D-4290965c.jpg";